// ============================================
// API 地址配置 - 改这里切换本地/线上
// ============================================

// 切换开关：true = 本地后端，false = 线上后端
const USE_LOCAL = false

// 本地后端地址（你本地运行的后端API地址）
const LOCAL_CONFIG = {
  // baseUrl: 'https://www.huigen.cc/api/',
  baseUrl: 'http://localhost:8000/api/',
  baseUrlimg: 'http://localhost:8000'
}

// 线上后端地址
const ONLINE_CONFIG = {
  baseUrl: 'https://www.huigen.cc/api/',
  baseUrlimg: 'https://www.huigen.cc'
}

// 当前使用的配置
const config = USE_LOCAL ? LOCAL_CONFIG : ONLINE_CONFIG

export default {
  baseUrl: config.baseUrl,
  baseUrlimg: config.baseUrlimg
}